/* eslint-disable import/prefer-default-export */

import { groupBy } from "ramda";

export const groupByCategory = data =>
  groupBy(blog => {
    const {
      node: {
        frontmatter: { category }
      }
    } = blog;

    return category;
  })(data);
